<template>
  <div>
    <div v-text="title" class="title"></div>
    <v-card outlined>
      <v-card-text>
        <v-row>
          <v-col v-for="photoIndex in imageNumber" :key="`${photoIndex}`" cols="6" lg="4" xl="3">
            <health-report-image ref="photo"></health-report-image>
            <!-- <span v-text="`image_${photoIndex}`"></span> -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import HealthReportImage from "./HealthReportImage";

export default {
  components: {
    HealthReportImage
  },
  props: ["reportId", "title", "imageNumber"],
  data: () => ({
    imageArray: [],
    uploadArray: []
  }),
  methods: {
    async getUploadImages() {
      let imageUrls = [];
      let thisVm = this;
      let localPhoto, photoUrl;
      for (let index = 0; index < this.imageNumber; index++) {
        localPhoto = thisVm.$refs.photo[index].getLoaclPhoto();
        photoUrl = thisVm.$refs.photo[index].getPhotoUrl();

        if (localPhoto) {
          //user upload new image
          const dataForm = new FormData();
          dataForm.append("photo", localPhoto);
          let response = await this.$ajax.post(
            `${this.$config.apiUrl}/${this.$my.getClinic()}/photo/${
              this.reportId
            }`,
            dataForm
          );
          console.log("response:" + JSON.stringify(response.data));
          imageUrls.push(response.data.path);
        } else if (photoUrl) {
          imageUrls.push(photoUrl);
        }
      }
      this.setImageArray(imageUrls);
      return imageUrls;
    },
    setImageArray(imageArray) {
      let thisVm = this;
      for (let index = 0; index < this.imageNumber; index++) {
        if (index < imageArray.length) {
          thisVm.$refs.photo[index].setPhotoUrl(imageArray[index]);
        } else {
          thisVm.$refs.photo[index].deleteAll();
        }
      }
    }
  },
  mounted() {
    console.log("imageNumber:" + this.imageNumber);
  }
};
</script>